<template>
  <v-card>
    <v-card-title class="headline">State of "{{ context.text }}"</v-card-title>
    <v-card-text>
      <v-btn v-if="!addingNewState" color="primary" @click="addNewState">Add a new state</v-btn>
      <v-timeline dense>
        <v-slide-x-reverse-transition group hide-on-leave>
          <v-timeline-item v-for="item in items" :key="item.id" :color="item.color" small left>
            <div v-if="item.create" class="py-4">
              <span class="caption">{{ item.date }}</span>
              <v-form @submit.prevent="saveNewState">
                <v-text-field
                  v-model="item.state"
                  autofocus
                  :color="item.color"
                  placeholder="Our current decision or next action..."
                  :class="`title font-weight-light mb-2 ${item.color}--text`"
                ></v-text-field>
                <v-textarea
                  v-model="item.description"
                  placeholder="Some details about the new state..."
                ></v-textarea>
                <v-btn :disabled="item.state.length == 0" class="primary mr-2" type="submit">
                  Save
                </v-btn>
                <v-btn class="" @click="cancelNew">Cancel</v-btn>
              </v-form>
            </div>
            <div v-else class="pt-4">
              <span class="caption">{{ item.createdOn | formatDate }}</span>
              <h2 :class="`title font-weight-light mb-2 ${item.color}--text`">{{ item.state }}</h2>
              <div v-if="item.description">
                {{ item.description }}
              </div>
            </div>
          </v-timeline-item>
        </v-slide-x-reverse-transition>
      </v-timeline>
    </v-card-text>
    <v-card-actions>
      <v-spacer></v-spacer>
      <template v-if="!addingNewState">
        <v-btn text @click="$emit('close')">Done</v-btn>
      </template>
    </v-card-actions>
  </v-card>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';

const COLORS = ['primary', 'green', 'error', 'warning'];

export default {
  data: () => ({
    addingNewState: false,
    items: [
      // {
      //   id: 2,
      //   color: 'info',
      //   date: 'January 12th, 2020',
      //   state: 'Try libreoffice to see if it works in a cloud function',
      //   description: `LibreOFfice seems like the best bet. Need to see if it actually works in a cloud function.`
      // },
      // {
      //   id: 1,
      //   color: 'error',
      //   date: 'January 3rd, 2020',
      //   state: 'Figure out what our options are',
      //   description: `We need to get the lay of the land.`
      // },
      // {
      //   id: 0,
      //   color: 'warning',
      //   date: 'January 3rd, 2020',
      //   state: 'Just created context',
      //   description: ``
      // }
    ]
  }),
  mounted() {
    if (this.context.states && this.context.states.length > 0) {
      this.items = [...this.context.states];
    } else {
      this.items.push({
        id: 1,
        color: 'warning',
        createdOn: this.context.createdOn,
        state: 'Just created context',
        description: ``
      });
    }
  },
  computed: {
    ...mapGetters('context', ['context'])
  },
  methods: {
    ...mapActions('context', ['updateContextStates']),
    addNewState() {
      this.addingNewState = true;
      const newState = {
        id: this.items.length + 1,
        color: this.genColor(),
        createdOn: new Date(),
        createdBy: '',
        create: true,
        state: '',
        description: ``
      };
      this.items.splice(0, 0, newState);
    },
    cancelNew() {
      this.items = this.items.slice(1);
      this.addingNewState = false;
    },
    saveNewState() {
      if (this.items[0].state.length > 0) {
        this.items[0].create = false;
        this.updateContextStates({ states: this.items });
        this.addingNewState = false;
      }
    },
    addEvent() {
      let { color, icon } = this.genAlert();

      const previousColor = this.items[0].color;

      while (previousColor === color) {
        color = this.genColor();
      }

      this.items.unshift({
        id: this.nonce++,
        color,
        icon
      });

      if (this.nonce > 6) {
        this.items.pop();
      }
    },
    genAlert() {
      const color = this.genColor();

      return {
        color
      };
    },
    genColor() {
      return COLORS[Math.floor(Math.random() * 3)];
    }
  }
};
</script>

<style></style>
